import gql from 'graphql-tag';

export default gql`
  query GetHistorySlides {
    getHistorySlides {
      id
      order
      detail {
        id
        language_code
        title
        description
        cta_label
        cta_url
      }
      updated_at
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/graphql/historySlide/getHistorySlides.js